(() => {
	const mobileMenu = document.querySelector('#nav-toggle');
	mobileMenu.addEventListener('change', () => {
		document.documentElement.classList.toggle('noscroll');
	});
})();
